import { makeVar, ReactiveVar } from "@apollo/client";

export type WebSocketState =
  | {
      status: null;
    }
  | {
      status: "retrying";
      timeUntilRetry: number;
    }
  | {
      status: "connecting";
    }
  | {
      status: "connected";
    }
  | {
      status: "closed";
    };

export const webSocketStateVar: ReactiveVar<WebSocketState> =
  makeVar<WebSocketState>({
    status: null,
  });
